import firebase from '../Firebase/firebaseConnection';
import NodeBackend from './NodeBackend';
const base = new NodeBackend().getPath();
export const timezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Toronto';
export const effective = (mode, zone = timezone()) => {
  if (mode !== 'auto') return mode;
  const hour = Number(new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: zone }).format(new Date()));
  return hour >= 5 && hour < 18 ? 'light' : 'dark';
};
export const applyAppearance = (mode, zone = timezone()) => {
  const theme = effective(mode, zone);
  document.documentElement.setAttribute('data-nextstock-theme', theme);
  localStorage.setItem('nextstock-theme', theme);
  localStorage.setItem('nextstock-appearance-mode', mode);
  localStorage.setItem('nextstock-appearance-timezone', zone);
  window.dispatchEvent(new CustomEvent('nextstock-appearance-changed', { detail: { mode, theme, timezone: zone } }));
};
const headers = async () => {
  const user = firebase.auth().currentUser;
  if (!user) throw new Error('Sign in required');
  return { Authorization: `Bearer ${await user.getIdToken()}` };
};
export async function loadAppearance() {
  const response = await fetch(base + 'appearance', { headers: await headers() });
  if (!response.ok) throw new Error('Unable to load appearance');
  const result = await response.json();
  applyAppearance(['light', 'dark', 'auto'].includes(result?.mode) ? result.mode : 'auto', result.timezone || timezone());
  return result;
}
export async function saveAppearance(mode, options = {}) {
  const zone = timezone();
  const response = await fetch(base + 'appearance', { method: 'PUT', signal: options.signal, headers: { ...(await headers()), 'Content-Type': 'application/json' }, body: JSON.stringify({ mode, timezone: zone }) });
  if (!response.ok) throw new Error('Unable to save appearance');
  applyAppearance(mode, zone);
}
